import { Folder } from '@dc-shared-web/hooks'
import { AxiosInstance } from 'axios'

export type CreateFolderParams = {
  name: string
  parent_uuid?: string
  parent_type?: 'folder' | 'project'
  office_uuid?: string
}

export const createFolder = async (
  apiClient: AxiosInstance,
  params: CreateFolderParams
): Promise<Folder> => {
  const { data } = await apiClient.post(`/api/folders`, {
    name: params.name,
    parent_uuid: params.parent_uuid,
    parent_type: params.parent_type,
    office_uuid: params.office_uuid,
  })

  return data
}
